import { IBayLevelData, ISizeSummary } from "open-vessel-definition";

/**
 * Whether a bay-level has the centerline row (00).
 * The vessel-wide flag is the default; a bay-level can only opt out by setting its own flag to 0.
 * `undefined` or 1 inherits the vessel-wide value.
 */
export function bayLevelHasCenterLineRow(
  sizeSummary: Pick<ISizeSummary, "centerLineRow">,
  bl: Pick<IBayLevelData, "centerLineRow"> | undefined,
): boolean {
  return !!sizeSummary.centerLineRow && bl?.centerLineRow !== 0;
}
